import React from 'react';
import PropTypes from 'prop-types';
import ProductVariationsProp from '../../propTypes/productVariationsProp';
import translate from '../../../../commonComponents/translate';

function CartItemName(props) {
  const { t, product } = props;
  const { isPack, name, variationName, isAdvancedPack, isHybridPack } = product;

  let packTag = isAdvancedPack ? t('shop.advancedPack') : t('shop.pack');
  if (isHybridPack) {
    packTag = t('shop.hybrid_pack');
  }
  return (
    <>
      <h3 className="cart-product-name">
        {isPack ? <span className="badge-pack">{packTag}</span> : null}
        {isPack ? name : variationName}
      </h3>
      {isPack && (
        <span style={{ color: 'var(--dynamic)', fontWeight: 500 }}>
          {variationName}
        </span>
      )}
    </>
  );
}

CartItemName.propTypes = {
  t: PropTypes.func.isRequired,
  product: PropTypes.shape(ProductVariationsProp.propType).isRequired,
};

export default translate(CartItemName);
